/* eslint-disable */
"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.WqlOperator = exports.UserStatusCriteriaEnum = exports.UserRoleCriteriaEnum = exports.TranslatableType = exports.StatusCodesHttpStatusCode = exports.Status = exports.SpiHttpStatusCode = exports.Sort = exports.SiteType = exports.ServiceAppendixType = exports.SegmentSegment = exports.PremiumLandingTabCriteriaEnum = exports.PremiumAccountCriteriaEnum = exports.Plan = exports.PersonType = exports.PermissionType = exports.PagingType = exports.OptimizeMode = exports.OperatorValueTypeEnum = exports.NullValue = exports.Method = exports.MessageAppendixType = exports.Maturity = exports.MailboxCriteriaEnum = exports.Label = exports.JSType = exports.IdempotencyLevel = exports.FrequencyCapsOverridesType = exports.FrequencyCapsEventType = exports.FreeSiteCriteriaEnum = exports.Format = exports.FieldDescriptorProtoType = exports.ExternalFilterCriteriaConditionTypeEnum = exports.ExternalCriteriaConditionTypeEnum = exports.Exposure = exports.EligibleForSaleCriteriaEnum = exports.DomainEventEventType = exports.CustomParamOperator = exports.CustomFilterDataSource = exports.CriteriaType = exports.CountType = exports.ConnectedDomainCriteriaEnum = exports.CompoundCriteriaOperator = exports.ComparatorTypeEnum = exports.CallbackEventType = exports.CType = exports.Brand = void 0;
var Brand;
(function (Brand) {
    Brand["UNKNOWN"] = "UNKNOWN";
    Brand["WIX"] = "WIX";
    Brand["EDITORX"] = "EDITORX";
    Brand["DAYFUL"] = "DAYFUL";
    Brand["STUDIO"] = "STUDIO";
})(Brand = exports.Brand || (exports.Brand = {}));
var CType;
(function (CType) {
    CType["STRING"] = "STRING";
    CType["CORD"] = "CORD";
    CType["STRING_PIECE"] = "STRING_PIECE";
})(CType = exports.CType || (exports.CType = {}));
var CallbackEventType;
(function (CallbackEventType) {
    CallbackEventType["UNKNOWN"] = "UNKNOWN";
    CallbackEventType["CREATED"] = "CREATED";
    CallbackEventType["UPDATED"] = "UPDATED";
    CallbackEventType["DELETED"] = "DELETED";
    CallbackEventType["ACTION"] = "ACTION";
})(CallbackEventType = exports.CallbackEventType || (exports.CallbackEventType = {}));
var ComparatorTypeEnum;
(function (ComparatorTypeEnum) {
    ComparatorTypeEnum["UNKNOWN"] = "UNKNOWN";
    ComparatorTypeEnum["EQUAL"] = "EQUAL";
    ComparatorTypeEnum["CONTAINED_IN"] = "CONTAINED_IN";
    ComparatorTypeEnum["CONTAINS_SOME"] = "CONTAINS_SOME";
    ComparatorTypeEnum["CONTAINS_NONE"] = "CONTAINS_NONE";
    ComparatorTypeEnum["NOT_CONTAINS"] = "NOT_CONTAINS";
    ComparatorTypeEnum["NOT_CONTAINED_IN"] = "NOT_CONTAINED_IN";
    ComparatorTypeEnum["BE_NOTHING"] = "BE_NOTHING";
    ComparatorTypeEnum["EXISTS"] = "EXISTS";
    ComparatorTypeEnum["MORE_THAN_DAYS"] = "MORE_THAN_DAYS";
    ComparatorTypeEnum["WITHIN_DAYS"] = "WITHIN_DAYS";
    ComparatorTypeEnum["LESS"] = "LESS";
    ComparatorTypeEnum["LESS_EQUAL"] = "LESS_EQUAL";
    ComparatorTypeEnum["GREATER"] = "GREATER";
    ComparatorTypeEnum["GREATER_EQUAL"] = "GREATER_EQUAL";
    ComparatorTypeEnum["SIZE_LESS_EQUAL"] = "SIZE_LESS_EQUAL";
    ComparatorTypeEnum["SIZE_GREATER_EQUAL"] = "SIZE_GREATER_EQUAL";
    ComparatorTypeEnum["NOT_EQUAL"] = "NOT_EQUAL";
})(ComparatorTypeEnum = exports.ComparatorTypeEnum || (exports.ComparatorTypeEnum = {}));
var CompoundCriteriaOperator;
(function (CompoundCriteriaOperator) {
    CompoundCriteriaOperator["UNKNOWN"] = "UNKNOWN";
    CompoundCriteriaOperator["OR"] = "OR";
    CompoundCriteriaOperator["AND"] = "AND";
})(CompoundCriteriaOperator = exports.CompoundCriteriaOperator || (exports.CompoundCriteriaOperator = {}));
var ConnectedDomainCriteriaEnum;
(function (ConnectedDomainCriteriaEnum) {
    ConnectedDomainCriteriaEnum["UNKNOWN"] = "UNKNOWN";
    ConnectedDomainCriteriaEnum["CONNECTED"] = "CONNECTED";
    ConnectedDomainCriteriaEnum["NOT_CONNECTED"] = "NOT_CONNECTED";
})(ConnectedDomainCriteriaEnum = exports.ConnectedDomainCriteriaEnum || (exports.ConnectedDomainCriteriaEnum = {}));
var CountType;
(function (CountType) {
    CountType["UNKNOWN"] = "UNKNOWN";
    CountType["TOTAL"] = "TOTAL";
    CountType["DAYS"] = "DAYS";
})(CountType = exports.CountType || (exports.CountType = {}));
var CriteriaType;
(function (CriteriaType) {
    CriteriaType["UNKNOWN"] = "UNKNOWN";
    CriteriaType["COMPOUND"] = "COMPOUND";
    CriteriaType["CUSTOM"] = "CUSTOM";
    CriteriaType["GEO"] = "GEO";
    CriteriaType["LANGUAGE"] = "LANGUAGE";
    CriteriaType["USER_ROLE"] = "USER_ROLE";
    CriteriaType["USER_STATUS"] = "USER_STATUS";
    CriteriaType["USER_COLORS"] = "USER_COLORS";
    CriteriaType["USER_GUIDS"] = "USER_GUIDS";
    CriteriaType["TEMPLATE_GUIDS"] = "TEMPLATE_GUIDS";
    CriteriaType["POST_REG"] = "POST_REG";
    CriteriaType["CONNECTED_DOMAIN"] = "CONNECTED_DOMAIN";
    CriteriaType["PREMIUM_PLAN"] = "PREMIUM_PLAN";
    CriteriaType["EXCLUDE_IN_SALE"] = "EXCLUDE_IN_SALE";
    CriteriaType["MAILBOX"] = "MAILBOX";
    CriteriaType["CONNECTED_OFFERING_GROUP"] = "CONNECTED_OFFERING_GROUP";
    CriteriaType["INSTALLED_APPS"] = "INSTALLED_APPS";
    CriteriaType["PRODUCT_GROUPS"] = "PRODUCT_GROUPS";
    CriteriaType["DOMAIN_LENGTH"] = "DOMAIN_LENGTH";
    CriteriaType["MAILBOX_SALE"] = "MAILBOX_SALE";
    CriteriaType["VOUCHERS"] = "VOUCHERS";
    CriteriaType["FREE_SITE"] = "FREE_SITE";
    CriteriaType["BRAND"] = "BRAND";
    CriteriaType["EXPERIMENT"] = "EXPERIMENT";
    CriteriaType["CUSTOM_PARAM"] = "CUSTOM_PARAM";
    CriteriaType["AUDIENCE"] = "AUDIENCE";
    CriteriaType["PREMIUM_LANDING_TAB"] = "PREMIUM_LANDING_TAB";
    CriteriaType["PREMIUM_ACCOUNT"] = "PREMIUM_ACCOUNT";
    CriteriaType["ELIGIBLE_FOR_SALE"] = "ELIGIBLE_FOR_SALE";
    CriteriaType["EXTERNAL_CRITERIA"] = "EXTERNAL_CRITERIA";
    CriteriaType["SITE_TYPE_CRITERIA"] = "SITE_TYPE_CRITERIA";
})(CriteriaType = exports.CriteriaType || (exports.CriteriaType = {}));
var CustomFilterDataSource;
(function (CustomFilterDataSource) {
    CustomFilterDataSource["UNKNOWN"] = "UNKNOWN";
    CustomFilterDataSource["USER_PROFILE"] = "USER_PROFILE";
    CustomFilterDataSource["SITE_PROFILE"] = "SITE_PROFILE";
})(CustomFilterDataSource = exports.CustomFilterDataSource || (exports.CustomFilterDataSource = {}));
var CustomParamOperator;
(function (CustomParamOperator) {
    CustomParamOperator["UNKNOWN"] = "UNKNOWN";
    CustomParamOperator["EQUALS"] = "EQUALS";
    CustomParamOperator["NOT_EQUALS"] = "NOT_EQUALS";
    CustomParamOperator["CONTAINS_ALL"] = "CONTAINS_ALL";
    CustomParamOperator["NOT_CONTAINS_ALL"] = "NOT_CONTAINS_ALL";
    CustomParamOperator["CONTAINS_ANY"] = "CONTAINS_ANY";
    CustomParamOperator["NOT_CONTAINS_ANY"] = "NOT_CONTAINS_ANY";
    CustomParamOperator["EXISTS"] = "EXISTS";
    CustomParamOperator["NOT_EXISTS"] = "NOT_EXISTS";
})(CustomParamOperator = exports.CustomParamOperator || (exports.CustomParamOperator = {}));
var DomainEventEventType;
(function (DomainEventEventType) {
    DomainEventEventType["UNKNOWN"] = "UNKNOWN";
    DomainEventEventType["CREATED"] = "CREATED";
    DomainEventEventType["UPDATED"] = "UPDATED";
    DomainEventEventType["DELETED"] = "DELETED";
    DomainEventEventType["ACTION"] = "ACTION";
})(DomainEventEventType = exports.DomainEventEventType || (exports.DomainEventEventType = {}));
var EligibleForSaleCriteriaEnum;
(function (EligibleForSaleCriteriaEnum) {
    EligibleForSaleCriteriaEnum["UNKNOWN"] = "UNKNOWN";
    EligibleForSaleCriteriaEnum["NONE"] = "NONE";
    EligibleForSaleCriteriaEnum["SEASONAL"] = "SEASONAL";
    EligibleForSaleCriteriaEnum["PERSONAL"] = "PERSONAL";
    EligibleForSaleCriteriaEnum["CUSTOM"] = "CUSTOM";
})(EligibleForSaleCriteriaEnum = exports.EligibleForSaleCriteriaEnum || (exports.EligibleForSaleCriteriaEnum = {}));
var Exposure;
(function (Exposure) {
    Exposure["PRIVATE"] = "PRIVATE";
    Exposure["INTERNAL"] = "INTERNAL";
    Exposure["PUBLIC"] = "PUBLIC";
})(Exposure = exports.Exposure || (exports.Exposure = {}));
var ExternalCriteriaConditionTypeEnum;
(function (ExternalCriteriaConditionTypeEnum) {
    ExternalCriteriaConditionTypeEnum["UNKNOWN"] = "UNKNOWN";
    ExternalCriteriaConditionTypeEnum["EQUAL"] = "EQUAL";
    ExternalCriteriaConditionTypeEnum["GREATER_THAN"] = "GREATER_THAN";
    ExternalCriteriaConditionTypeEnum["SMALLER_THAN"] = "SMALLER_THAN";
})(ExternalCriteriaConditionTypeEnum = exports.ExternalCriteriaConditionTypeEnum || (exports.ExternalCriteriaConditionTypeEnum = {}));
var ExternalFilterCriteriaConditionTypeEnum;
(function (ExternalFilterCriteriaConditionTypeEnum) {
    ExternalFilterCriteriaConditionTypeEnum["UNKNOWN"] = "UNKNOWN";
    ExternalFilterCriteriaConditionTypeEnum["EQUAL"] = "EQUAL";
    ExternalFilterCriteriaConditionTypeEnum["GREATER_THAN"] = "GREATER_THAN";
    ExternalFilterCriteriaConditionTypeEnum["SMALLER_THAN"] = "SMALLER_THAN";
    ExternalFilterCriteriaConditionTypeEnum["CONTAINS_ALL"] = "CONTAINS_ALL";
    ExternalFilterCriteriaConditionTypeEnum["CONTAINS_SOME"] = "CONTAINS_SOME";
    ExternalFilterCriteriaConditionTypeEnum["NOT_CONTAINS_SOME"] = "NOT_CONTAINS_SOME";
    ExternalFilterCriteriaConditionTypeEnum["NOT_CONTAINS_ALL"] = "NOT_CONTAINS_ALL";
    ExternalFilterCriteriaConditionTypeEnum["BE_NOTHING"] = "BE_NOTHING";
    ExternalFilterCriteriaConditionTypeEnum["EXISTS"] = "EXISTS";
    ExternalFilterCriteriaConditionTypeEnum["MORE_THAN_DAYS"] = "MORE_THAN_DAYS";
    ExternalFilterCriteriaConditionTypeEnum["WITHIN_DAYS"] = "WITHIN_DAYS";
    ExternalFilterCriteriaConditionTypeEnum["NOT_EQUAL"] = "NOT_EQUAL";
})(ExternalFilterCriteriaConditionTypeEnum = exports.ExternalFilterCriteriaConditionTypeEnum || (exports.ExternalFilterCriteriaConditionTypeEnum = {}));
var FieldDescriptorProtoType;
(function (FieldDescriptorProtoType) {
    FieldDescriptorProtoType["TYPE_DOUBLE"] = "TYPE_DOUBLE";
    FieldDescriptorProtoType["TYPE_FLOAT"] = "TYPE_FLOAT";
    FieldDescriptorProtoType["TYPE_INT64"] = "TYPE_INT64";
    FieldDescriptorProtoType["TYPE_UINT64"] = "TYPE_UINT64";
    FieldDescriptorProtoType["TYPE_INT32"] = "TYPE_INT32";
    FieldDescriptorProtoType["TYPE_FIXED64"] = "TYPE_FIXED64";
    FieldDescriptorProtoType["TYPE_FIXED32"] = "TYPE_FIXED32";
    FieldDescriptorProtoType["TYPE_BOOL"] = "TYPE_BOOL";
    FieldDescriptorProtoType["TYPE_STRING"] = "TYPE_STRING";
    FieldDescriptorProtoType["TYPE_GROUP"] = "TYPE_GROUP";
    FieldDescriptorProtoType["TYPE_MESSAGE"] = "TYPE_MESSAGE";
    FieldDescriptorProtoType["TYPE_BYTES"] = "TYPE_BYTES";
    FieldDescriptorProtoType["TYPE_UINT32"] = "TYPE_UINT32";
    FieldDescriptorProtoType["TYPE_ENUM"] = "TYPE_ENUM";
    FieldDescriptorProtoType["TYPE_SFIXED32"] = "TYPE_SFIXED32";
    FieldDescriptorProtoType["TYPE_SFIXED64"] = "TYPE_SFIXED64";
    FieldDescriptorProtoType["TYPE_SINT32"] = "TYPE_SINT32";
    FieldDescriptorProtoType["TYPE_SINT64"] = "TYPE_SINT64";
})(FieldDescriptorProtoType = exports.FieldDescriptorProtoType || (exports.FieldDescriptorProtoType = {}));
var Format;
(function (Format) {
    Format["EMAIL"] = "EMAIL";
    Format["HOSTNAME"] = "HOSTNAME";
    Format["IPV4"] = "IPV4";
    Format["IPV6"] = "IPV6";
    Format["URI"] = "URI";
    Format["WEB_URL"] = "WEB_URL";
    Format["PHONE"] = "PHONE";
    Format["CREDIT_CARD"] = "CREDIT_CARD";
    Format["GUID"] = "GUID";
    Format["COUNTRY"] = "COUNTRY";
    Format["LANGUAGE"] = "LANGUAGE";
    Format["DECIMAL_VALUE"] = "DECIMAL_VALUE";
    Format["CURRENCY"] = "CURRENCY";
    Format["LANGUAGE_TAG"] = "LANGUAGE_TAG";
    Format["COLOR_HEX"] = "COLOR_HEX";
    Format["LOCAL_DATE"] = "LOCAL_DATE";
    Format["LOCAL_TIME"] = "LOCAL_TIME";
    Format["LOCAL_DATE_TIME"] = "LOCAL_DATE_TIME";
    Format["URL_SLUG"] = "URL_SLUG";
    Format["SYSTEM_SLUG"] = "SYSTEM_SLUG";
})(Format = exports.Format || (exports.Format = {}));
var FreeSiteCriteriaEnum;
(function (FreeSiteCriteriaEnum) {
    FreeSiteCriteriaEnum["UNKNOWN"] = "UNKNOWN";
    FreeSiteCriteriaEnum["HAS_FREE"] = "HAS_FREE";
    FreeSiteCriteriaEnum["NO_FREE"] = "NO_FREE";
})(FreeSiteCriteriaEnum = exports.FreeSiteCriteriaEnum || (exports.FreeSiteCriteriaEnum = {}));
var FrequencyCapsEventType;
(function (FrequencyCapsEventType) {
    FrequencyCapsEventType["UNKNOWN"] = "UNKNOWN";
    FrequencyCapsEventType["VIEW"] = "VIEW";
    FrequencyCapsEventType["MAIN_CTA_CLICK"] = "MAIN_CTA_CLICK";
    FrequencyCapsEventType["SKIP"] = "SKIP";
    FrequencyCapsEventType["UNSKIP"] = "UNSKIP";
    FrequencyCapsEventType["CLOSE"] = "CLOSE";
    FrequencyCapsEventType["SHOW_LATER"] = "SHOW_LATER";
})(FrequencyCapsEventType = exports.FrequencyCapsEventType || (exports.FrequencyCapsEventType = {}));
var FrequencyCapsOverridesType;
(function (FrequencyCapsOverridesType) {
    FrequencyCapsOverridesType["UNKNOWN"] = "UNKNOWN";
    FrequencyCapsOverridesType["PLACEMENT_LEVEL"] = "PLACEMENT_LEVEL";
    FrequencyCapsOverridesType["OFFER_LEVEL"] = "OFFER_LEVEL";
})(FrequencyCapsOverridesType = exports.FrequencyCapsOverridesType || (exports.FrequencyCapsOverridesType = {}));
var IdempotencyLevel;
(function (IdempotencyLevel) {
    IdempotencyLevel["IDEMPOTENCY_UNKNOWN"] = "IDEMPOTENCY_UNKNOWN";
    IdempotencyLevel["NO_SIDE_EFFECTS"] = "NO_SIDE_EFFECTS";
    IdempotencyLevel["IDEMPOTENT"] = "IDEMPOTENT";
})(IdempotencyLevel = exports.IdempotencyLevel || (exports.IdempotencyLevel = {}));
var JSType;
(function (JSType) {
    JSType["JS_NORMAL"] = "JS_NORMAL";
    JSType["JS_STRING"] = "JS_STRING";
    JSType["JS_NUMBER"] = "JS_NUMBER";
})(JSType = exports.JSType || (exports.JSType = {}));
var Label;
(function (Label) {
    Label["LABEL_OPTIONAL"] = "LABEL_OPTIONAL";
    Label["LABEL_REQUIRED"] = "LABEL_REQUIRED";
    Label["LABEL_REPEATED"] = "LABEL_REPEATED";
})(Label = exports.Label || (exports.Label = {}));
var MailboxCriteriaEnum;
(function (MailboxCriteriaEnum) {
    MailboxCriteriaEnum["UNKNOWN"] = "UNKNOWN";
    MailboxCriteriaEnum["HAS_MAILBOX"] = "HAS_MAILBOX";
    MailboxCriteriaEnum["NO_MAILBOX"] = "NO_MAILBOX";
})(MailboxCriteriaEnum = exports.MailboxCriteriaEnum || (exports.MailboxCriteriaEnum = {}));
var Maturity;
(function (Maturity) {
    Maturity["ALPHA"] = "ALPHA";
    Maturity["BETA"] = "BETA";
    Maturity["IA"] = "IA";
    Maturity["GA"] = "GA";
    Maturity["NOT_IMPLEMENTED"] = "NOT_IMPLEMENTED";
})(Maturity = exports.Maturity || (exports.Maturity = {}));
var MessageAppendixType;
(function (MessageAppendixType) {
    MessageAppendixType["UNKNOWN_APPENDIX_TYPE"] = "UNKNOWN_APPENDIX_TYPE";
    MessageAppendixType["AUTO_VELO"] = "AUTO_VELO";
    MessageAppendixType["DOCS_CONF"] = "DOCS_CONF";
    MessageAppendixType["MULTILINGUAL"] = "MULTILINGUAL";
})(MessageAppendixType = exports.MessageAppendixType || (exports.MessageAppendixType = {}));
var Method;
(function (Method) {
    Method["UNKNOWN_METHOD"] = "UNKNOWN_METHOD";
    Method["CREATE"] = "CREATE";
    Method["GET_ITEM"] = "GET_ITEM";
    Method["UPDATE"] = "UPDATE";
    Method["DELETE"] = "DELETE";
    Method["UPSERT"] = "UPSERT";
    Method["LIST"] = "LIST";
    Method["QUERY"] = "QUERY";
    Method["SEARCH"] = "SEARCH";
    Method["BULK_CREATE"] = "BULK_CREATE";
    Method["BULK_UPDATE"] = "BULK_UPDATE";
    Method["BULK_UPDATE_BY_FILTER"] = "BULK_UPDATE_BY_FILTER";
    Method["BULK_DELETE"] = "BULK_DELETE";
    Method["BULK_DELETE_BY_FILTER"] = "BULK_DELETE_BY_FILTER";
    Method["BULK_UPSERT"] = "BULK_UPSERT";
    Method["LIST_DELETED"] = "LIST_DELETED";
    Method["GET_DELETED"] = "GET_DELETED";
    Method["RESTORE_FROM_TRASHBIN"] = "RESTORE_FROM_TRASHBIN";
    Method["REMOVE_FROM_TRASHBIN"] = "REMOVE_FROM_TRASHBIN";
    Method["COUNT"] = "COUNT";
})(Method = exports.Method || (exports.Method = {}));
var NullValue;
(function (NullValue) {
    NullValue["NULL_VALUE"] = "NULL_VALUE";
})(NullValue = exports.NullValue || (exports.NullValue = {}));
var OperatorValueTypeEnum;
(function (OperatorValueTypeEnum) {
    OperatorValueTypeEnum["UNKNOWN"] = "UNKNOWN";
    OperatorValueTypeEnum["NUMBER"] = "NUMBER";
    OperatorValueTypeEnum["STRING"] = "STRING";
    OperatorValueTypeEnum["LIST"] = "LIST";
    OperatorValueTypeEnum["TIMESTAMP"] = "TIMESTAMP";
    OperatorValueTypeEnum["BOOLEAN"] = "BOOLEAN";
})(OperatorValueTypeEnum = exports.OperatorValueTypeEnum || (exports.OperatorValueTypeEnum = {}));
var OptimizeMode;
(function (OptimizeMode) {
    OptimizeMode["SPEED"] = "SPEED";
    OptimizeMode["CODE_SIZE"] = "CODE_SIZE";
    OptimizeMode["LITE_RUNTIME"] = "LITE_RUNTIME";
})(OptimizeMode = exports.OptimizeMode || (exports.OptimizeMode = {}));
var PagingType;
(function (PagingType) {
    PagingType["UNKNOWN_TYPE"] = "UNKNOWN_TYPE";
    PagingType["OFFSET"] = "OFFSET";
    PagingType["CURSOR"] = "CURSOR";
})(PagingType = exports.PagingType || (exports.PagingType = {}));
var PermissionType;
(function (PermissionType) {
    PermissionType["AUTO"] = "AUTO";
    PermissionType["MANUAL"] = "MANUAL";
})(PermissionType = exports.PermissionType || (exports.PermissionType = {}));
var PersonType;
(function (PersonType) {
    PersonType["USER"] = "USER";
    PersonType["SITEMEMBER"] = "SITEMEMBER";
    PersonType["VISITOR"] = "VISITOR";
})(PersonType = exports.PersonType || (exports.PersonType = {}));
var Plan;
(function (Plan) {
    Plan["UNKNOWN"] = "UNKNOWN";
    Plan["PREMIUM"] = "PREMIUM";
    Plan["NONE"] = "NONE";
})(Plan = exports.Plan || (exports.Plan = {}));
var PremiumAccountCriteriaEnum;
(function (PremiumAccountCriteriaEnum) {
    PremiumAccountCriteriaEnum["UNKNOWN"] = "UNKNOWN";
    PremiumAccountCriteriaEnum["IS_PREMIUM"] = "IS_PREMIUM";
    PremiumAccountCriteriaEnum["IS_NOT_PREMIUM"] = "IS_NOT_PREMIUM";
})(PremiumAccountCriteriaEnum = exports.PremiumAccountCriteriaEnum || (exports.PremiumAccountCriteriaEnum = {}));
var PremiumLandingTabCriteriaEnum;
(function (PremiumLandingTabCriteriaEnum) {
    PremiumLandingTabCriteriaEnum["UNKNOWN"] = "UNKNOWN";
    PremiumLandingTabCriteriaEnum["WEBSITE"] = "WEBSITE";
    PremiumLandingTabCriteriaEnum["BUSINESS"] = "BUSINESS";
})(PremiumLandingTabCriteriaEnum = exports.PremiumLandingTabCriteriaEnum || (exports.PremiumLandingTabCriteriaEnum = {}));
var SegmentSegment;
(function (SegmentSegment) {
    SegmentSegment["UNSPECIFIED"] = "UNSPECIFIED";
    SegmentSegment["USERS"] = "USERS";
    SegmentSegment["PUBLIC"] = "PUBLIC";
    SegmentSegment["OTHERS"] = "OTHERS";
})(SegmentSegment = exports.SegmentSegment || (exports.SegmentSegment = {}));
var ServiceAppendixType;
(function (ServiceAppendixType) {
    ServiceAppendixType["UNKNOWN_APPENDIX_TYPE"] = "UNKNOWN_APPENDIX_TYPE";
    ServiceAppendixType["NILE"] = "NILE";
    ServiceAppendixType["MESSAGE_BUS"] = "MESSAGE_BUS";
})(ServiceAppendixType = exports.ServiceAppendixType || (exports.ServiceAppendixType = {}));
var SiteType;
(function (SiteType) {
    SiteType["UNKNOWN"] = "UNKNOWN";
    SiteType["REGULAR"] = "REGULAR";
    SiteType["HEADLESS"] = "HEADLESS";
})(SiteType = exports.SiteType || (exports.SiteType = {}));
var Sort;
(function (Sort) {
    Sort["NONE"] = "NONE";
    Sort["ASC"] = "ASC";
    Sort["DESC"] = "DESC";
    Sort["BOTH"] = "BOTH";
})(Sort = exports.Sort || (exports.Sort = {}));
var SpiHttpStatusCode;
(function (SpiHttpStatusCode) {
    SpiHttpStatusCode["UNKNOWN_ERROR"] = "UNKNOWN_ERROR";
    SpiHttpStatusCode["UNAUTHENTICATED"] = "UNAUTHENTICATED";
    SpiHttpStatusCode["INVALID_ARGUMENT"] = "INVALID_ARGUMENT";
    SpiHttpStatusCode["INTERNAL"] = "INTERNAL";
    SpiHttpStatusCode["RESOURCE_EXHAUSTED"] = "RESOURCE_EXHAUSTED";
    SpiHttpStatusCode["CANCELED"] = "CANCELED";
    SpiHttpStatusCode["NOT_FOUND"] = "NOT_FOUND";
    SpiHttpStatusCode["ALREADY_EXISTS"] = "ALREADY_EXISTS";
    SpiHttpStatusCode["FAILED_PRECONDITION"] = "FAILED_PRECONDITION";
})(SpiHttpStatusCode = exports.SpiHttpStatusCode || (exports.SpiHttpStatusCode = {}));
var Status;
(function (Status) {
    Status["UNKNOWN"] = "UNKNOWN";
    Status["ALL"] = "ALL";
    Status["WIX_EMPLOYEE"] = "WIX_EMPLOYEE";
})(Status = exports.Status || (exports.Status = {}));
var StatusCodesHttpStatusCode;
(function (StatusCodesHttpStatusCode) {
    StatusCodesHttpStatusCode["OK"] = "OK";
    StatusCodesHttpStatusCode["UNAUTHENTICATED"] = "UNAUTHENTICATED";
    StatusCodesHttpStatusCode["PERMISSION_DENIED"] = "PERMISSION_DENIED";
    StatusCodesHttpStatusCode["INVALID_ARGUMENT"] = "INVALID_ARGUMENT";
    StatusCodesHttpStatusCode["NOT_FOUND"] = "NOT_FOUND";
    StatusCodesHttpStatusCode["INTERNAL"] = "INTERNAL";
    StatusCodesHttpStatusCode["UNAVAILABLE"] = "UNAVAILABLE";
    StatusCodesHttpStatusCode["RESOURCE_EXHAUSTED"] = "RESOURCE_EXHAUSTED";
    StatusCodesHttpStatusCode["CANCELED"] = "CANCELED";
    StatusCodesHttpStatusCode["ALREADY_EXISTS"] = "ALREADY_EXISTS";
    StatusCodesHttpStatusCode["FAILED_PRECONDITION"] = "FAILED_PRECONDITION";
})(StatusCodesHttpStatusCode = exports.StatusCodesHttpStatusCode || (exports.StatusCodesHttpStatusCode = {}));
var TranslatableType;
(function (TranslatableType) {
    TranslatableType["UNDEFINED_TYPE"] = "UNDEFINED_TYPE";
    TranslatableType["SHORT_TEXT"] = "SHORT_TEXT";
    TranslatableType["LONG_TEXT"] = "LONG_TEXT";
    TranslatableType["RICH_TEXT"] = "RICH_TEXT";
    TranslatableType["RICH_CONTENT_EDITOR"] = "RICH_CONTENT_EDITOR";
    TranslatableType["SELECTION"] = "SELECTION";
    TranslatableType["MULTI_SELECTION"] = "MULTI_SELECTION";
    TranslatableType["DOCUMENT"] = "DOCUMENT";
    TranslatableType["IMAGE"] = "IMAGE";
    TranslatableType["VIDEO"] = "VIDEO";
    TranslatableType["IMAGE_LINK"] = "IMAGE_LINK";
})(TranslatableType = exports.TranslatableType || (exports.TranslatableType = {}));
var UserRoleCriteriaEnum;
(function (UserRoleCriteriaEnum) {
    UserRoleCriteriaEnum["UNKNOWN"] = "UNKNOWN";
    UserRoleCriteriaEnum["OWNER"] = "OWNER";
    UserRoleCriteriaEnum["NOT_OWNER"] = "NOT_OWNER";
})(UserRoleCriteriaEnum = exports.UserRoleCriteriaEnum || (exports.UserRoleCriteriaEnum = {}));
var UserStatusCriteriaEnum;
(function (UserStatusCriteriaEnum) {
    UserStatusCriteriaEnum["UNKNOWN"] = "UNKNOWN";
    UserStatusCriteriaEnum["NEW"] = "NEW";
})(UserStatusCriteriaEnum = exports.UserStatusCriteriaEnum || (exports.UserStatusCriteriaEnum = {}));
var WqlOperator;
(function (WqlOperator) {
    WqlOperator["ALL_APPLICABLE_OPERATORS"] = "ALL_APPLICABLE_OPERATORS";
    WqlOperator["EQ"] = "EQ";
    WqlOperator["GT"] = "GT";
    WqlOperator["GTE"] = "GTE";
    WqlOperator["IN"] = "IN";
    WqlOperator["LT"] = "LT";
    WqlOperator["LTE"] = "LTE";
    WqlOperator["NE"] = "NE";
    WqlOperator["NIN"] = "NIN";
    WqlOperator["BEGINS"] = "BEGINS";
    WqlOperator["EXISTS"] = "EXISTS";
    WqlOperator["ALL"] = "ALL";
    WqlOperator["HAS_ALL"] = "HAS_ALL";
    WqlOperator["ANY"] = "ANY";
    WqlOperator["HAS_SOME"] = "HAS_SOME";
    WqlOperator["EMPTY"] = "EMPTY";
})(WqlOperator = exports.WqlOperator || (exports.WqlOperator = {}));
//# sourceMappingURL=types.js.map